import React from "react";

const Header = () => {
  return (
    <>
      <div className="col-md-4 left pr-md-0 d-none d-md-flex flex-column">
        <div className="logo-container">
          <a href="/" title="Reklamacje Integrum">
            <img src="amberline_logo.png" width="250" alt="Amberline logo" />
          </a>
          <a href="/" title="Reklamacje Integrum">
            <div className="info-icon">
              <i className="fas fa-info"></i>
            </div>
          </a>
        </div>
        <div className="bg-images position-relative">
          <div className="complaint-visible">
            <img src="amberline_form_image_complaint.png" alt="Amberline" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
